import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';

/**
 *
 */
EDC.Animations.Shape = function (scene) {
  this.scene = scene;
  this.shape = null;
  this.cursorManager = scene.cursorManager;
  this.origin = new Phaser.Geom.Point(0, 0);
  this.sizeIndex = -1;
  this.container = null;
  this.markAnim = null;
  this.hoverAnim = null;
};
/**
 *
 */
EDC.Animations.Shape.prototype.create = function (name, sizeIndex) {
  this.sizeIndex = sizeIndex;

  this.container = this.scene.add.container(0, 0);

  this.shape = this.scene.add.sprite(0, 0, name);
  this.container.add(this.shape);

  this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);

  const containerBounds = this.container.getBounds();
  this.container.setSize(containerBounds.width, containerBounds.height);
  this.container.setInteractive();

  this.scene.input.setDraggable(this.container);

  this.container.on(
    'drag',
    function (pointer, dragX, dragY) {
      this.container.x = dragX;
      this.container.y = dragY;
    },
    this,
  );

  this.container.on('dragend', this.onDragStop, this);
  this.container.on('dragstart', this.onDragStart, this);

  this.cursorManager.setDefaultDraggableEvents(this.container);
};
/**
 *
 */
EDC.Animations.Shape.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
  this.origin.setTo(x, y);
};
/**
 *
 */
EDC.Animations.Shape.prototype.moveToOrigin = function () {
  this.scene.tweens.add({
    targets: this.container,
    x: this.origin.x,
    y: this.origin.y,
    duration: 300,
    ease: 'Back.easeOut',
  });
};

EDC.Animations.Shape.prototype.release = function () {
  this.scene.tweens.add({
    targets: this.container,
    x: this.origin.x,
    y: this.origin.y,
    duration: 300,
    ease: 'Back.easeOut',
    onComplete: this.hover.bind(this),
  });
};
/**
 *
 */
EDC.Animations.Shape.prototype.getHeight = function () {
  return this.container.getBounds().height;
};
/**
 *
 */
EDC.Animations.Shape.prototype.getPosition = function () {
  return { x: this.container.x, y: this.container.y };
};
/**
 *
 */
EDC.Animations.Shape.prototype.getBounds = function () {
  return this.container.getBounds();
};
/**
 *
 */
EDC.Animations.Shape.prototype.onDragStart = function () {
  this.stopHover();
};
/**
 *
 */
EDC.Animations.Shape.prototype.onDragStop = function () {
  this.scene.drop(this);
};
/**
 *
 */
EDC.Animations.Shape.prototype.getSizeIndex = function () {
  return this.sizeIndex;
};
/**
 *
 */
EDC.Animations.Shape.prototype.destroy = function () {
  this.container.destroy();
};
/**
 *
 */
EDC.Animations.Shape.prototype.disable = function () {
  this.container.removeInteractive();
};
/**
 *
 */
EDC.Animations.Shape.prototype.showMark = function (isWrong, correctCallback) {
  if (isWrong) {
    this.shape.setTint(0xff0000);
  }
  this.markAnim.showMark(
    !isWrong,
    () => {
      this.cursorManager.resetCursor();
      if (isWrong) {
        this.moveToOrigin();
        this.disable();
      } else {
        correctCallback();
      }
    },
  );
};
/**
 *
 */
EDC.Animations.Shape.prototype.disappear = function (callback) {
  this.scene.tweens.add({
    targets: this.container,
    alpha: 0,
    duration: 400,
    ease: 'Linear',
    onComplete() {
      callback();
    },
  });
};

EDC.Animations.Shape.prototype.hover = function () {
  const randomDuration = 800 + Math.round(Math.random() * 400);
  this.hoverAnim = this.scene.tweens.add({
    targets: this.container,
    y: this.origin.y - 10,
    ease: 'Sine.easeInOut',
    duration: randomDuration,
    yoyo: true,
    onComplete: this.hover.bind(this),
  });
};

EDC.Animations.Shape.prototype.stopHover = function () {
  this.hoverAnim.stop();
};

export default EDC.Animations.Shape;
